const NavData = [
  {
    to: '#home',
    text: 'होमपेज',
  },
  {
    to: '#our-story',
    text: 'हाम्रो बारेमा',
  },
  {
    to: '#self-assessment',
    text: 'स्वमूल्यांकन जाँच',
  },
];

const surveyPageData = {
  nepali: {
    surveyHeader:
      'उदासपन र चिन्ताको स्वमूल्यांकन चेकलिस्ट (K10 टेस्ट)',
    surveyIntro: [
      'यो साधारण जाँच सूचीको उद्देश्य विगतका चार हप्तामा तपाई उदासपन र चिन्ताको समस्याबाट प्रभावित हुनु भयो कि भएन भनेर मापन गर्नको लागि हो। तपाईको जत्ति बढि अंक आँउछ त्यति नै बढि तपाईले उदासपन र चिन्ताको समस्या भोगिरहेको सम्भावना बढी हुन्छ र सोही अनुसार परामर्श र सहयोग लिनुपर्ने हुन्छ । तपाईको विचार, भावना र व्यवहारलाई प्रतिनिधित्व गर्ने गरी तलका उत्तरहरुको विकल्प रोज्नुहोला ।',
    ],
    quizSectionHeader: 'गत ४ हप्तादेखि ...',
    kesslerQuestions: [
      'गत ४ हप्तादेखि कुनै खास कारण नभएपनि तपाईले प्राय कत्तिको थाकेको अनुभव गर्नु भएको छ ?',
      'गत ४ हप्तादेखि तपाई कति पटक आत्तिनु भएको छ?',
      'गत ४ हप्तादेखि तपाई कति पटक केहीले पनि शान्त पार्न नसक्ने गरी आत्तिनु भएको थियो?',
      'गत ४ हप्तादेखि तपाई कति पटक निराश हुनुभएको थियो?',
      'गत ४ हप्तादेखि तपाईले कति पटक बेचैन वा छटपटाहट महसुस गर्नुभएको थियो?',
      'गत ४ हप्तादेखि तपाई कति पटक स्थिर भएर बस्नै नसक्ने गरी बेचैन हुनुभएको थियो?',
      'गत ४ हप्तादेखि तपाई कति पटक उदास हुनुभएको थियो?',
      'गत ४ हप्तादेखि तपाईलाई कति पटक सबै काम गर्न गाह्रो लागेको जस्तो महसुस भएको थियो?',
      'गत ४ हप्तादेखि तपाईलाई कति पटक कुनै पनि कुराले खुसी बनाउन नसक्ने गरी दिक्क लागेको थियो?',
      'गत ४ हप्तादेखि तपाईले कति पटक आफू मूल्यहीन भएको जस्तो महसुस गर्नु भएको थियो?',
    ],
    answerOptions: {
      long: [
        'कुनै पनि बेला गरिन',
        'थोरै मात्र',
        'केही पटक',
        'प्राय जसो',
        'सधै भरी',
      ],
      short: [
        'कुनै पनि बेला गरिन',
        'थोरै मात्र',
        'केही पटक',
        'प्राय जसो',
        'सधै भरी',
      ],
    },
    emailPrompt:
      'तपाईको अंक ईमेलमा पठाइनेछ। आफ्नो ईमेल तल भरेर बुझाउनुहोला।',
    actionText: 'बुझाउनुहोस्',
  },
  english: {
    surveyHeader: 'Anxiety and Depression Checklist (K10 assessment)',
    surveyIntro: [
      'This simple checklist aims to measure whether you may have been affected by depression and anxiety during the past four weeks. The higher your score, the more likely you are to be experiencing depression and/or anxiety.',
      'These questions relate to how you have been feeling over the past four weeks. Tick a box next to each question that best reflects your thoughts, feelings and behaviour.',
    ],
    quizSectionHeader: 'In the past for weeks...',
    kesslerQuestions: [
      'In the past 4 weeks, about how often did you feel tired out for no good reason?',
      'In the past 4 weeks, about how often did you feel nervous?',
      'In the past 4 weeks, about how often did you feel so nervous that nothing could calm you down?',
      'In the past 4 weeks, about how often did you feel hopeless?',
      'In the past 4 weeks, about how often did you feel restless or fidgety?',
      'In the past 4 weeks, about how often did you feel so restless you could not sit still?',
      'In the past 4 weeks, about how often did you feel depressed?',
      'In the past 4 weeks, about how often did you feel that everything was an effort?',
      'In the past 4 weeks, about how often did you feel so sad that nothing could cheer you up?',
      'In the past 4 weeks, about how often did you feel worthless?',
    ],
    answerOptions: {
      long: [
        'None of the time',
        'A little of the time',
        'Some of the time',
        'Most of the time',
        'All of the time',
      ],
      short: ['None', 'Little', 'Some', 'Most', 'All'],
    },
    emailPrompt:
      'Score will be sent to your email. Please submit with your email address.',
    actionText: '',
  },
};

const surveySuccessPage = {
  english: {
    message:
      'Thank you for doing the screening test. Your score has been sent to your email address. Please check you email for further instructions.',
    backLinkText: 'Back to Home',
  },
  nepali: {
    message: [
      'स्वमूल्यांकन जाँचको परिणाम तपाईको ईमेलमा पठाइएको छ। थप निर्देशनको लागि आफ्नो ईमेल चेक गर्नुहोला।',
      'परिणामको ईमेल कहिलेकाँही inbox मा नगएर spam वा junk फोल्डरमा जान सक्छ । कृपया ईमेलको spam र junk फोल्डर चेक गर्न नभुल्नु होला ।',
    ],
    backLinkText: 'होमपेज',
  },
};

const aboutUsData = {
  nepali: {
    header: 'हाम्रो बारेमा',
    description: [
      'स्वस्थ जीवनको पूर्ण लाभ लिनलाई जीवनका सबै पक्षहरु (शारीरिक, भावनात्मक, मनोवैज्ञानिक, आर्थिक र सामाजिक) सन्तुलित हुनुपर्छ । तर शारीरिक स्वास्थ्य बाहेक अन्य पक्षहरु सम्बन्धी नकारात्मक सोच, गलत बुझाई र भेदभावको डरले हामीले यी आवश्यकताहरुलाई बेवास्ता गर्छौ । यसरी लामो समय सम्म भावनाहरुलाई मनमा दबाएर राख्दा आफ्नो दैनिक जीवन, शारीरिक स्वास्थ्य मात्र नभई आफ्नो परिवार र समाजलाई पनि नराम्रो प्रभाव पर्न सक्छ ।',
      'इच्छाशक्तिको सुरुवात सबैलाई भावनात्मक र मनोवैज्ञानिक कल्याणको बारेमा छलफल गर्न एउटा सुरक्षित र प्रेरणामूलक वातावरण तयार गर्नको लागि भएको हो । सबैले स्वास्थ्य सम्बन्धित जानकारी सजिलै लिन पाउनु, यसको बारे खुला रुपमा छलफल गर्न पाउनुको साथै आवश्यक सहयोग र परामर्श लिन पाउनु पर्छ भन्ने सोचका साथ हामीले यो मंचको सृजना गरेका छौं। ',
      'हामी तपाईको सुवास्थ्यको यात्रामा साथ दिन तयार छौं । के तपाई तयार हुनुहुन्छ ?',
    ],
    sections: [
      {
        header: 'स्वमूल्यांकन र स्क्रीनिंगका अनलाइन विधिहरु',
        description: [
          'लक्षणको पहिचान र आफ्नो संघर्षलाइ स्वीकार गर्नु स्वास्थ्यलाभको लागि पहिलो कदम हो। यस वेबसाइटमा रहेका विभिन्न किसिमका स्वमूल्यांकन र स्क्रीनिंगका विधिहरु प्रयोग गरेर तपाईले आफ्नो मनोस्थितिको मूल्यांकन गर्न सक्नुहुनेछ ।',
        ],
      },
      {
        header: 'मनस् ज्ञानकोश',
        description: [
          'हाम्रो लक्ष्य स्वास्थ्यको सबैभन्दा बेवास्ता गरिएको पक्ष - मनस् अर्थात् mind लाई राम्ररी बुझ्न र बुझाउन विभिन्न स्रोत र साधनहरु, नयाँ दृष्टिकोण र विकल्पहरुको संग्रह (मनस् ज्ञानकोश) तयार गर्ने हो । समुदायमा मनस् (mind) लाई विशेष चासो र छलफलको विषय बनाउन यो सम्बन्धी विविध माध्यमबाट अनुसन्धान र प्रमाणमा आधारित ज्ञान र जानकारी प्रस्तुत गर्नेछौं । यो ज्ञानकोशले हामीलाई आफ्नो मनस्, विचार र भावनालाई बुझेर जीवनमा सकारात्मक परिवर्तन ल्याउन सहयोग गर्नेछ ।',
        ],
      },
      {
        header: 'प्रेरणा मञ्च',
        description: [
          'सबैको आ-आफ्नो जीवन कथा हुन्छ । यी कथाहरुले कसैलाई प्रेरणा दिन सक्छ त कसैको जीवन नै परिवर्तन गर्न सक्छ । तपाईहरुबाट पनि सबैको मन छुने प्रेरणात्मक कथाहरु र अनुभवहरु सुन्न हामी उत्साहित छौं ।',
        ],
      },
    ],
  },
  english: {
    header: 'About us',
    description: [
      'Ichhya was created to foster a community where people feel safe and encouraged to learn and discuss about psychological distress and seek help. We believe that anyone, anywhere should easily and effectively get the information and help they need to enjoy emotional and psychological well being and a healthy life. Fear of stigma, judgement and social isolation should not discourage people from sharing their feelings with others, accessing information and getting support in order to improve their wellbeing and quality of life.',
      'We are dedicated to help people achieve better mental wellbeing and to make a real and lasting impact on people and community. We look forward to fulfill our mission to reach as many nepalese people around the globe. We are ready to be a part of your journey to better psychological wellbeing. Are you ?',
    ],
    sections: [
      {
        header: 'Online self-assessment and screening tools',
        description: [
          'We believe that recognition of symptoms and acknowledgement of psychological distress is the first step to recovery. We make wide ranging standard self assessment tools of stress, depression and anxiety available to people.',
        ],
      },
      {
        header: 'Campaigns against stigma, judgement and isolation',
        description: [
          'Fear of stigma, judgement and isolation discourages people to open up about our internal struggle. We pledge to make it our mission to reach as many nepalese as possible around the world to build a warm and open community.',
          'Please support us on our mission to empower people to take control of their mental wellbeing.',
        ],
      },
      {
        header: 'Stories and shared experience',
        description: [
          'Icchya is built on a foundation of lived experience and belief that our story can be the change we have been waiting for. The more we talk about it, the more the stigma will be reduced.',
          'We are keen to hear and share more stories. The story could be as simple as what you do manage your stress in daily life , how you have helped someone you know who was going through a tough time. If you care, please share.',
        ],
      },
    ],
  },
};

const preranaManchPage = {
  pageHeader: 'प्रेरणा मञ्च',
};

const preranaManchStoryOne = {
  title: 'दयालु परिवारको उदाहरण',
  paragraphs: [
    'कोभिड १९ को यो माहामारीमा ओम बुढाथोकी र वहाँको परिवार दिनहु व्यस्त हुनुहुन्छ । वहाँहरुले दिनको करिब ६०० माथिको हाराहारीमा आवश्यक परेकालाई खाना खुवाउने कार्यमा लाग्नु भएको छ । यस कार्यबाट विपत्तिमा परेका धेरै मानिसहरु मात्र नभई सुरक्षाकर्मी, समाजसेवी, आनाथालय र अस्पतालमा कुरुवा बसेकाहरुले पनि भोक मेट्न पाएका छन् ।',
    'यो माहामारीका कारण दैनिक जीविकोपार्जनमा समस्या परेकालाई सहयोग गर्ने मनसायले ओम जी ले परिवारसंग मिलेर आज हजारौको पेट भर्ने क्रममा हुनहुन्छ । यसरी आफ्नो सानो प्रयासले कसैको गाँसको व्यवस्था हुँदा यो दयालु परिवारलाई थप उर्जा प्राप्त भएको बताउनुहुन्छ ।',
    'रामेछाप गाउँका ओम जीलाई जीवनमा कुनै बेला आफुले पनि अरुबाट सानो वा ठुलो सहयोग (Act of Kindess) पाउनुभएको थियो कि भनि सोध्दा वहाँले सानो छदाँ रुखबाट खसेर बेहोश भएको बेला कसैले बोकेर घर सम्म लगेर लगाएको ठुलो गुण जिन्दगीमा कहिले न बिर्सने बताउनुभयो ।',
    'बुढाथोकी परिवारको यो उदारपन र सेवाको भाव समाजमा एउटा दयामय कार्यको उदाहरण बनेको छ । वहाँको यो कथाले अरुलाई पनि प्रेरित गर्नेछ भन्ने आशा राखेका छौँ ।',
  ],
};

const preranaManchStoryAaratiArticle = {
  title: 'तपाइँको कल्याण तपाइँबाट शुरू हुन्छ: मेरो अनुभव',
  paragraphs: [
    '"जरैबाट महिलाको स्थिति बदल्न सम्भव छ यदि सामाजिक, परिवार र घरेलु अस्तित्वका सबै 	सर्तहरू परिवर्तन भए।" Leon Trotsky in Women and the Family',
    'हिन्दू धर्ममा, महिला देवीको रूपमा पूजा गरिन्छ, कुमारी, जीवित देवीको रूपमा होस्; देवी दुर्गाको रूपमा जसले समाजमा शान्ति पुनर्स्थापनाका लागि राक्षसहरूलाई मार्नुभयो वा अर्धनारेश्वर, दायाँतर्फ शिव र बायाँमा पार्वतीले संकेत गर्छ कि पुरुष र महिला अविभाज्य शक्तिहरू हुन् र सन्तुलन कायम गर्न उनीहरूमिलेर काम गर्नुपर्दछ।',
    'माथिका कडा धार्मिक विश्वास र अभ्यासहरूको बाबजुद पनि, महिलालाई अझै पनि परिवार र समाजमा अधीन स्थान दिइन्छ। सोचाइमा परम्परागत र परम्परागत उत्सव मनाउनमा आधूनिकता अपनाउने यस समाजको हिस्सा म विगत दुई दशक भन्दा बढीदेखि छु । यस समाजमा एउटी केटीको रूपमा मीठो र नमीठो दुबै क्षणहरू देख्दै आएकी छु जुन सायद एउटा केटा बच्चाले विरलै सामना गर्छ। साथीहरुसंग बाहिर जानको लाभ उठाउन होस् वा खानामा मात्र बाँकी-अण्डा उपभोग गर्नको अवसर, त्यो सुख केटा बच्चाले मात्र अनुभव गर्छ ।',
    'यस सम्बन्धमा, यदि मैले मेरो जीवन समाजको इच्छा अनुरुप बाचेको भए, आज म कसैको भान्छामा बिहानको पाँच बजेदेखि रात्रीको १० बजे सम्म खाना पकाउदैमा जान्थ्यो। तर मैले मेरो जीवन आफ्नै तरिकाले बाच्ने छनौट गरे र आज म जो छु, म जहाँ छु, त्यसमा म गर्व गर्दछु। हो, तथापि म गल्ती गर्छु, तर त्यसको पूर्ण जिम्मेवारी पनि लिन्छु । गल्तीबाट शिक्षा लिन्छु, अनि आफ्नो हरेक गल्ती नदोहोर्याउनु प्रयास गर्छु ।',
    'यसको लागि, पहिलो र सबैभन्दा महत्त्वपूर्ण कुरा हो, शिक्षा जसले एक व्यक्तिमा मानसिक, शारीरिक, भावनात्मक र आध्यात्मिक प्रतिभालाई प्रोत्साहित गर्दछ। शैक्षिक प्रमाणपत्रहरूले हाम्रो भविष्य सृजना गर्न महत्वपूर्ण भूमिका खेल्छन, यसका साथै प्रश्न गर्ने दिमागले हामीलाई वास्तविकतासँग रूबरू गराउन मदत गर्छ । यो सरल छ, यदि म नयाँ स्नातक हुँ भने, मलाई जागिर चाहिन्छ, मैले सर्वप्रथम पदहरूको लागि आवेदन दिनुपर्छ । मेरो शैक्षिक योग्यता, जागरुक प्रबृतिले मलाई सही अवसरहरु संग मेल खान मदत गर्छ । मैले आफ्नो क्यारियरको सुरुमा यो गरे र यसले मेरो आगामी क्यारियर छनौटहरूको लागि उत्प्रेरकको रूपमा काम गर्ने आधार प्रदान गर्यो। मैले प्रयास बिना केवल अवसरको लागि पर्खिरहेका धेरै मानिसहरूलाई देखेको छु, उनीहरु केवल अवसरले मेरो ढोका ढकढक्याउँछ अनि म दुवै हातले समाउछु भनेर मात्र पर्खिबस्छन । यो उनीहरुले जीवनमा गर्ने सबैभन्दा ठूलो गल्ती हो ।',
    'यस पछि अर्को हो, हाम्रो समर्थन समूह, जसमा परिवार, साथी वा सहकर्मी जो कोही पनि हुनसक्छन। हामी सामाजिक प्राणी हौं, हामी मानिसहरूलाई कुरा गर्न आवश्यक छ। यो सरल छ, जब हामी जे र जुनसुकै कुरा, चाहे त्यो सानो होस वा ठूलो , यदि हामीले आदानप्रदान गर्यौ भने त्यसले आश्चर्यचकित ढंगबाट काम गर्छ । यसो गर्दा हामीले जटिल समस्याहरूको पनि सजिलो समाधान फेला पार्नसक्छौ, मैले फेला पारेको छु र म बिस्वस्त छु कि तपाई  सबैजनाले पनि पक्कै पाउनु भएको छ । हाम्रा अभिभावकहरूले प्रायः साथीहरूको आवश्यकता पर्दैन भनेर भन्छन्, यद्यपि, साँचो र सीमित मित्रहरू कुनै पनि र सबै अवस्थामा तपाईंको साथमा उभिन्छन्। जीवनमा पैसा भन्दा साथीहरू कमाउनुहोस्।',
    'जब हामी एक भन्दा बढी व्यक्तिहरूसँग बस्छौं, स्पष्ट रूपमा त्यहाँ कोही मानिसहरू हुन्छन, जो हामीले जे गरे पनि असहमत हुन्छन, अनि नकारात्मक टिप्पणीहरू बाट हाम्रो मनोबल घटाउने प्रयास गर्छन। जे होस्, यदि हामीलाई थाहा छ कि हामी ठीक छौं र हामीहरू आफ्नो निर्णयमा पूर्ण विश्वास गर्छौं भने, हामीले अरूले भनेको कुराले आफुलाई असर गर्न दिनुहुन्न । उदहारणको लागि मेरो साथीको जन्मदिन मनाउन उसको घरमा रातिमा बस्नको लागि अग्रिम अनुमति लिनुपर्छ मैले आफ्नो  घरमा, येतिमात्र नभएर साथीको घरको ठेगाना देखि सम्पर्क विवरण दिन आवश्यक हुन्छ । तर घरमा ती "दुष्ट" भाइहरू वा दिदीबहिनी हुन्छन जसले हाम्रा अविभावकहरूलाई मूर्खतापूर्ण स्पष्टीकरणहरू दिएर उनीहरुको मन भ्रस्ट पारिदिन्छन। दृढ खडा हुनुहोस् र मानिसका कुराबाट टाढा हुनुहोस्।',
    'त्यस्तै मसंग पैसा छ भने, उदहारणको लागि मेरो गोजीमा १०० रुपैयाको नोट छ, र म यसलाई बुद्धिमानीपूर्वक प्रयोग गर्न सक्षम भएन भने, म दु: खी महसुस गर्छु। जब हामी हरेक हिसाब वित्त प्रबन्ध गर्न सक्षम हुन्छौं, त्यतिबेला हामी एक- एक पैसा खर्च गर्दा खुसीको अनुभव गर्छौ। हामीले राम्रो योजना बनाएनौं भने, हामी मिडास राजा जस्तै हुनेछौं, जो धनी थियो तर उसको सम्पत्तीले उसलाई खानेकुरा किन्न सकेन। आफ्नै कुरा गर्दा मैले ठूलो नोक्सान भोग्नु परेको छ, नराम्रो विकल्पहरू रोजेको थिए जसले गर्दा पछुताउनु परेको छ; बिस्तारै यो कला म आफैं पनि सिक्दैछु।',
    'अन्तमा, व्यक्तिले जीवनमा सफल हुनको लागि दीर्घकालिक दृष्टिकोण राख्नुपर्छ जहाँ सबै प्रत्याशित र अप्रत्याशित जोखिमहरूको लागि शमन उपायहरू समायोजन गरिएको छन। हामी मध्ये धेरैले दीर्घकालिक दृष्टिकोण त बनाउँछौ तर त्यसमा चुनौतीहरु सामना गर्ने उपायहरु हुँदैनन, यसले गर्दा पटक-पटक हामी असफल हुन्छौँ र अन्ततः हाम्रो आत्मबिश्वास तोड्छ। यो सबै हाम्रो हातमा छ, जुनसुकै हामी जो सुकै भएपनि आफ्नो आस्तित्वमा रमाउने सक्छौँ।',
    'जीवन एउटै मात्र छ, र यसलाई हामी जस्तो चाहन्छौं त्यसरी नै बनाऔं!!!',
  ],
};

const SuicideAmongMenPage = {
  title: 'पुरुषहरु बीच आत्महत्या',
  sections: [
    {
      title: '',
      contents: [
        {
          type: 'paragraph',
          text:
            'यो लेख पुरुष र आत्महत्याको बारेमा एक्मुस्ट संकलन गरिएको सामग्री हो । यो स्रोत पुरुषहरु बीच आत्महत्या ( Suicide among men ) को बारेमा सबैलाई जानकारी दिनलाई तयार गरिएको हो । तपाईहरुले पुरुष र आत्महत्या सम्बन्धी तथ्यांक, आत्महत्याको चेतावनी दिने संकेतहरु (warning signs of suicide), आत्महत्याको जोखिम कारकहरु, किन पुरुषहरू बढी जोखिममा छन्, र यो समुहमा कसरी आत्महत्या रोक्न सकिन्छ भन्ने जानकारी प्राप्त गर्नुहुनेछ ।',
        },
        {
          type: 'paragraph',
          text:
            'यदि तपाई कसैलाई चिन्नुहुन्छ जो आत्महत्याको बारेमा सोच्दै छ, वा यदि तपाईलाई आत्महत्याको सोचाई आईरहेकोछ भने, वा तपाईको घर परिवार, साथीहरू तथा समुदायमा तल उल्लेखित चेतावनीका संकेतहरु देखियो भने सहयोग को लागि तपाईको स्थानीय हेल्प लाइनमा सम्पर्क गर्नुहोस् ।',
        },
        {
          type: 'ul',
          texts: [
            'पाटन अस्पताल हटलाइन सुसाइड रोकथाम - २४ घण्टा : ९८१३४७६१२३',
            'TUTH सुसाइड हटलाइन - २४ घण्टा: ९८४००२१६००',
          ],
        },
      ],
    },
    {
      title: 'तथ्यांक',
      contents: [
        {
          type: 'ol',
          texts: [
            '१) विश्वमा प्रत्येक ४० सेकेन्डमा एक जनाले, एक दिनमा ३००० जनाले र  एक बर्षमा ८,००,०००  जनाले आत्महत्या गर्छन् । - WHO, 2016',
            '२) आत्महत्या गर्ने व्यक्तिको संख्यामा नेपाल सातौं स्थानमा पर्छ र दक्षिण एसियामा श्रीलंका पछि दोस्रो स्थानमा पर्छ ।',
            '३) नेपालमै प्रतिदिन औसतमा १९ जनाले आत्महत्या गर्ने गरेको प्रहरीको तथ्यांकले देखाउछ ।',
            '४) २०१७ मा सबै देशहरूमा आत्महत्याको दर महिलाहरू भन्दा पुरुषहरूमा बढी थियो । ',
            '५) विस्तृत राष्ट्रिय तथ्यांकको अभावको कारणले गर्दा नेपालमा लैंगिक आत्महत्याको दरको तुलना गर्न र निष्कर्षमा पुग्न गाह्रो छ । विश्व स्वास्थ्य संगठनको दक्षिण पूर्व एशिया क्षेत्रका अन्य सदस्य राज्यहरुको अनुपात १.१: १.५ जस्तै समग्रमा महिलाहरुको अनुपातमा पुरुषहरुको बीचमा आत्महत्या बढी रहेको देखिन्छ ।',
          ],
        },
      ],
    },
    {
      title: 'आत्महत्याको चेतावनी दिने संकेतहरु (warning signs)',
      contents: [
        {
          type: 'paragraph',
          text:
            'विज्ञहरुका अनुसार हरेक व्यक्तिले आत्महत्या गर्ने सोच पहिल्यै कुनै न कुनै मध्यमबाट अभिव्यक्त गरेको हुन्छ । व्यवहारमा अचानक कुनै ठुलो परिवर्तन देखिनु पनि कुनै समस्याको संकेत हुन सक्छ।',
        },
        {
          type: 'paragraph',
          text: 'सामान्य संकेतहरु यस्तो हुनसक्छ :',
        },
        {
          type: 'ol',
          texts: [
            '- समान्यतया रुची लिने र रमाउने गतिबिधिहरुमा रुचि गुमाउने',
            '- परिवार र साथीहरूबाट टाढा हुने',
            '- सुत्ने वा खाने बानीमा परिवर्तन हुने : अधिक निदाउने- दिनको समयमा समेत, छटपटिएर निदाउन नसक्ने, कम खाने र दुब्लाउने, वा अत्यधिक खाने र मोटाउने',
            '- सामान्य भन्दा बढी रक्सी पिउने वा लागुपदार्थ लिने',
            '- बढ्दो चिढचिढापन र रिस',
            '- भावनाहरु दबाउने वा अस्वीकार गर्ने',
            '- हताश भएको वा अरुको लागि बोझ भएको जस्तो भावना व्यक्त गर्ने ',
            '- सामान्य कुराकानीमा पनि बाच्न मन नलागेको भावनाहरु पोख्ने',
            '- आत्महत्या गर्ने तरिका खोजिरहेको वा योजना बनाइसकेको',
          ],
        },
      ],
    },
    {
      title: 'आत्महत्याको जोखिम कारकहरु',
      contents: [
        {
          type: 'paragraph',
          text:
            'आत्महत्या वा आत्महत्या-प्रयासका तीन मुख्य जोखिम कारकहरु',
        },
        {
          type: 'ol',
          texts: [
            '१) अन्तर्निहित तनाव',
            '२) विचलित मानसिक स्थिति वा मानसिक रोग ',
            '३) परिस्थितिहरूले आत्महत्याको पहुँचलाई सजिलो बनाउँदा ',
          ],
        },
        {
          type: 'paragraph',
          text:
            'हालसालै गरिएको अध्ययनहरूका अनुसार मनोवैज्ञानिक रोगहरुका कारण गरिने आत्महत्याहरु प्रायः दुई तिहाई केसहरूमा पर्दछन् भने बाँकीको तिहाई केसहरू आवेगमा गरिने पाइएको छ। (शाक्य, २०१४)',
        },
        {
          type: 'paragraph',
          text:
            'आत्महत्याको प्रयास गर्नेहरू बीच देखा परेको साझा तनावहरू यी हुन्:',
        },
        {
          type: 'ol',
          texts: [
            '- पारस्परिक द्वन्द्व / विवाद',
            '- स्वास्थ / उपचार सम्बन्धित',
            '- आफन्त वा नजिकको मानिसको मृत्यु',
            '- नजिकको मानिसद्वारा लागुपदार्थको दुर्व्यवहार',
            '- कमजोर आर्थिक स्थिति',
            '- अशक्तता',
            '- आत्महत्यामा प्रयोग गरिने सामग्रीहरुको सजिलो पहुच ',
          ],
        },
      ],
    },
    {
      title: 'किन पुरुषहरू आत्महत्याको बढी जोखिममा छन् ?',
      contents: [
        {
          type: 'paragraph',
          text:
            'निम्न कारणहरुले गर्दा पुरुषहरुमा आत्महत्याको जोखिम बढी हुनसक्छ ।',
        },
        {
          type: 'subtitle',
          text:
            '१) समाजले निर्धारण गरेको लैंगिक भूमिकाले पुरुषहरुमा भावनात्मक अभिव्यक्ति निरुत्साहित गर्दछ ।',
        },
        {
          type: 'paragraph',
          text:
            'भावनात्मक अभिव्यक्तिलाई उनीहरूको पुरुषत्वमा एक दागको रूपमा हेरिन्छ । पुरुषहरु बलियो हुनुपर्छ, भावुक हुनु हुन्न, आर्थिक रुपमा पनि बलियो हुनुपर्छ भन्ने समाजका लैंगिक नियमहरुले पुरुषहरुलाई अप्ठ्यारो र आवश्यक परेको बेला अरुसँग कुरा गर्न र सहयोग लिनबाट रोक्दछ । उनीहरुले सहयोग खोज्नको साटो आफ्नो तनाब दबाउने, हानिकारक र हिंसात्मक ब्यवहार र कार्यहरू मार्फत भावना र पीडाको निकास गर्दछन् ।',
        },
        {
          type: 'subtitle',
          text:
            '२) पुरुषहरुले भावनाहरु कम व्यक्त गर्ने हुदा उनीहरुमा उदासीपन ( डिप्रेसन ) जस्ता मानसिक रोग कम पत्ता लाग्ने गर्दछ ।',
        },
        {
          type: 'subtitle',
          text:
            '३) पुरुषहरूले भावनात्मक समस्याहरूको लागि सहयोग लिने सम्भावना पनि कम हुन्छ ।',
        },
        {
          type: 'subtitle',
          text:
            '४) उदासीनताको लक्षण र सम्बन्धित भावनाहरुको सामना गर्न गाह्रो भएर मदिरा र अन्य पदार्थहरू सेवन गर्न तिर लाग्न सक्छन् ।',
        },
        {
          type: 'paragraph',
          text:
            'मदिरापान आत्महत्याको कारकको रुपमा परिचित छ ।  मदिरा सेवनले झन् निराश बनाउन र आवेगपूर्ण आनीबानी बढाउन सक्छ ।',
        },
      ],
    },
    {
      title: 'पुरुषहरूमा आत्महत्या कसरी रोक्न सकिन्छ ?',
      contents: [
        {
          type: 'subtitle',
          text: '१) डिप्रेसनको संकेत राम्ररी अवलोकन गर्नुहोस् ।',
        },
        {
          type: 'paragraph',
          text:
            'पुरुषहरूमा उदासीनताको लक्षणहरूमा चिढचिढापन, समाजबाट टाढा हुने, चिन्ता, रुचि वा खुशी कम हुने, शारीरिक पीडा र गुनासो, जोखिमपूर्ण व्यवहारमा संलग्नता, लागूऔषध र मदिराको दुरुपयोग, र सामान्य दैनिक कार्यहरू जारी राख्न असमर्थ हुने आदि पर्दछन् ।',
        },
        {
          type: 'subtitle',
          text: '२) मदतको प्रस्ताब गर्नुहोस्',
        },
        {
          type: 'paragraph',
          text:
            'यदि तपाईले डिप्रेसनको संकेत देख्नु भएमा, सहयोग गर्न तपाईले के गर्न सक्नुहुन्छ भनेर सोध्नुहोस् । यदि केहि समस्या भए र समस्याको बारेमा तपाई सँग छलफल गर्न सहज महसुस भए, तपाई सुन्न र मद्दत गर्न इच्छुक हुनुहुन्छ भनेर थाहा दिनुहोस्।',
        },
        {
          type: 'subtitle',
          text: '३) आत्महत्याको संकेतलाई बेवास्था नगर्नुहोस्',
        },
        {
          type: 'paragraph',
          text:
            'आत्महत्याको संकेत गर्ने विचार वा व्यवहारलाई हल्का रुपमा नलिनुहोस् र बेवास्ता नगर्नुहोस् । यदि तपाईले आत्मघाती कुराकानी वा विचार सुन्नुभयो भने, उसलाई मनोचिकित्षक, मनोविमर्शकर्ता वा तलको नम्बरमा फोन गरेर कुरा गर्न प्रोत्साहन दिनुहोस् ।',
        },
        {
          type: 'ul',
          texts: [
            'पाटन अस्पताल हटलाइन सुसाइड रोकथाम - २४ घण्टा : ९८१३४७६१२३',
            'TUTH सुसाइड हटलाइन - २४ घण्टा: ९८४००२१६००',
          ],
        },
      ],
    },
    {
      subtitle: 'References',
      contents: [
        {
          type: 'captions',
          texts: [
            '1. Hannah Ritchie, Max Roser and Esteban Ortiz-Ospina (2015) - Suicide. Published online at OurWorldInData.org',
            '2. Marahatta , Reuben Samuel , Pawan Sharma , Lonim Dixit , Bhola Ram Shrestha (2017) Suicide burden and prevention in Nepal: the need for a national strategy Kedar . WHO South-East Asia Journal of Public Health 6(1), 45-49',
            '3. Dhana Ratna Shakya (2014) Common Stressors among Suicide Attempters as Revealed in a Psychiatric Service of Eastern Nepal. Journal of Traumatic Stress Disorders & Treatment 3:3',
            '4. Purushottam P. Khatri (2020) Suicide Living cause of deaths. The Rising Nepal',
            '5. जनकराज सापकोटा, गोकर्ण गौतम (२०२०) ‘लाइभ’ गरेर ‘लाइफ’ समाप्त ! . कान्तिपुर',
            '6. Jerry Kennard, PhD (2020) Understanding suicide among men . https://www.verywellmind.com/men-and-suicide-2328492',
          ],
        },
      ],
    },
  ],
};

const manasGyankoshPage = {
  pageHeader: 'मनस् ज्ञानकोश',
};

export {
  NavData,
  surveyPageData,
  surveySuccessPage,
  aboutUsData,
  preranaManchPage,
  preranaManchStoryOne,
  preranaManchStoryAaratiArticle,
  manasGyankoshPage,
  SuicideAmongMenPage,
};
